import { LOCAL__grid2d_cells_upsert } from '@/state/grid2d/grid2d_cell/LOCAL__grid2d_cells_upsert';
import { store } from '@/state/store';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { FN_GRID2D_CELL__try_set_image } from './_methods/FN_GRID2D_CELL__try_set_image';

export function HANDLER_CLIENT__grid2d_cells_upsert(items: any) {
  assert_array_instanceof(items, DTO__grid2d_cell);

  items.map(FN_GRID2D_CELL__try_set_image);

  store.dispatch(LOCAL__grid2d_cells_upsert(items));
}
